// import Profile from '../../common/lib/models/profile';
// import ProfilePaymentDetail from '../../common/lib/models/profile-payment-detail';
// import ProfileOwner from '../../common/lib/models/profile-owner';
// import ProfileAddress from '../../common/lib/models/profile-address';
// import ProfileAffilation from '../../common/lib/models/profile-affiliation';
// import ProfileReference from '../../common/lib/models/profile-reference';
// import ProfileContact from '../../common/lib/models/profile-contact';
// import ProfileTaxInfo from '../../common/lib/models/profile-tax-info';
// import ProfileDiversity from '../../common/lib/models/profile-diversity';
// import ProfileDiversityCertificate from '../../common/lib/models/profile-diversity-certificate';
// import ProfileInsuranceInfo from '../../common/lib/models/profile-insurance-info';
// import ProfileInsurancePolicy from '../../common/lib/models/profile-insurance-policy';
// import ProfileLicense from '../../common/lib/models/profile-license';
// import ProfileProductInfo from '../../common/lib/models/profile-product-info';
// import ProfileSustainabilityInfo from '../../common/lib/models/profile-sustainability-info';
// import ProfileTask from '../../common/lib/models/profile-task';
import * as moment from 'moment';

export class APIError {
  constructor(
    type?: string,
    message?: string,
    details?: string,
    template?: string
  ) {
    if (type) {
      this.type = type;
    }
    if (message) {
      this.message = message;
    }
    if (details) {
      this.details = details;
    }

    if (template) {
      this.template = template;
    }
  }
  message: string;
  type: string;
  details: string;
  template: string;
}

export class IDAttribute {
  private _value: number | undefined;

  constructor(v?: number) {
    this._value = v;
  }

  get value(): number | undefined {
    return this._value;
  }

  set value(v: number | undefined) {
    if (!this._value) {
      this._value = v;
    }
  }

  toString(): string {
    if (this._value) {
      return this._value.toString();
    }
    return '';
  }
}

export class StringAttribute {
  private _required: boolean;
  private _maxLength: number | undefined;
  private _value: string | undefined;
  private _error: string | undefined;

  constructor(v?: string) {
    this._value = v;
  }

  get value(): string | undefined {
    return this._value;
  }

  set value(v: string | undefined) {
    if (this._maxLength && v && v.length > this._maxLength) {
      v = v.substring(0, this._maxLength - 1);
    }
    this._value = v;
  }

  get error(): string | undefined {
    return this._error;
  }

  set error(v: string | undefined) {
    this._error = v;
  }

  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  get maxLength(): number | undefined {
    return this._maxLength;
  }

  set maxLength(v: number | undefined) {
    this._maxLength = v;
  }

  isValid = (showErrors: boolean) => {
    if (
      this.required &&
      (this._value === undefined || this._value === null || this.value === '')
    ) {
      if (showErrors && !this._error) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors && this._error == 'This field is required') {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    if (typeof e === 'string') {
      this._value = e;
      return;
    }
    this._value = e.target.value;
  };
}

export class NumberAttribute {
  private _required: boolean;
  private _value: number | undefined;
  private _error: string | undefined;

  constructor(v?: number) {
    this._value = v;
  }

  get value(): string | number | undefined {
    return this._value;
  }

  // TODO: What if number starts as negative (-)
  // TODO: What if number starts witha decimal (.)
  // TODO: What if number ends in decimal
  set value(v: string | number | undefined) {
    if (v == null || v == undefined) {
      this._value = undefined;
    } else {
      switch (typeof v) {
        case 'string':
          try {
            this._value = parseFloat(v as string);
          } catch (error) {
            // No need to do anything here, the internal _value will simply not get updated.
          }
          break;
        case 'number':
          this._value = v as number;
          break;
      }
    }
  }

  get error(): string | undefined {
    return this._error;
  }

  set error(v: string | undefined) {
    this._error = v;
  }
  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  isValid = (showErrors: boolean) => {
    if (this.required && (this._value === undefined || this._value === null)) {
      if (showErrors) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors) {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    var v;
    if (e && e.target) {
      v = e.target.value;
    } else {
      v = e;
    }

    if (v == null || v == undefined) {
      this._value = undefined;
    } else {
      switch (typeof v) {
        case 'string':
          try {
            this._value = parseFloat(v as string);
          } catch (error) {
            // No need to do anything here, the internal _value will simply not get updated.
          }
          break;
        case 'number':
          this._value = v as number;
          break;
      }
    }
  };
}

export class MoneyAttribute extends NumberAttribute {
  // TODO: jdouglas - fill out these methods with a floating point safe library
  add(value: MoneyAttribute): MoneyAttribute {
    return value;
  }
  subtract(value: MoneyAttribute): MoneyAttribute {
    return value;
  }

  multiply(value: MoneyAttribute): MoneyAttribute {
    return value;
  }
  divide(value: MoneyAttribute): MoneyAttribute {
    return value;
  }
}

export class DateAttribute {
  private _required: boolean;
  private _value: Date | undefined;
  private _error: string | undefined;

  constructor(v?: Date) {
    if (v) {
      if (typeof v == 'string') {
        let newVal = moment(v);
        if (newVal.isValid) {
          newVal.add(newVal.toDate().getTimezoneOffset(), 'm');
          this._value = newVal.toDate();
        }
      } else {
        this._value = moment(v)
          .add(v.getTimezoneOffset(), 'm')
          .toDate();
      }
    } else {
      this._value = v;
    }
  }

  get value(): Date | undefined {
    // convert the stored UTC date as a local date with no time component
    return this._value;
  }

  set value(v: Date | undefined) {
    if (v) {
      // convert to UTC date with no time value for the purpose of storing the date
      if (typeof v == 'string') {
        let newVal = moment(v);
        if (newVal.isValid) {
          newVal.add(newVal.toDate().getTimezoneOffset(), 'm');
          this._value = newVal.toDate();
        }
      } else {
        this._value = moment(v)
          .add(v.getTimezoneOffset(), 'm')
          .toDate();
      }
    } else {
      this._value = v;
    }
  }

  get error(): string | undefined {
    return this._error;
  }
  set error(v: string | undefined) {
    this._error = v;
  }
  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  isValid = (showErrors: boolean) => {
    if (this.required && (this._value === undefined || this._value === null)) {
      if (showErrors) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors) {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    this._value = e.target.value;
  };
}

export class DateTimeAttribute {
  private _required: boolean;
  private _value: Date | undefined;
  private _error: string | undefined;

  constructor(v?: Date) {
    this._value = v;
  }

  get value(): Date | undefined {
    return this._value;
  }

  set value(v: Date | undefined) {
    this._value = v;
  }

  get error(): string | undefined {
    return this._error;
  }
  set error(v: string | undefined) {
    this._error = v;
  }
  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  isValid = (showErrors: boolean) => {
    if (this.required && (this._value === undefined || this._value === null)) {
      if (showErrors) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors) {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    this._value = e.target.value;
  };
}

export class ObjectAttribute {
  private _required: boolean;
  private _value: any | undefined;
  private _error: string | undefined;

  constructor(v?: any) {
    this._value = v;
  }

  get value(): any | undefined {
    return this._value;
  }

  set value(v: any | undefined) {
    this._value = v;
  }

  get error(): string | undefined {
    return this._error;
  }
  set error(v: string | undefined) {
    this._error = v;
  }
  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  isValid = (showErrors: boolean) => {
    if (
      this.required &&
      (this._value === undefined ||
        this._value === null ||
        Object.keys(this._value).length == 0)
    ) {
      if (showErrors) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors) {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    this._value = e;
  };
}

export class ArrayAttribute {
  private _required: boolean;
  private _value: any | undefined;
  private _error: string | undefined;

  constructor(v?: any) {
    this._value = v;
  }

  get value(): Array<any> | undefined {
    return this._value;
  }

  set value(v: Array<any> | undefined) {
    this._value = v;
  }

  get error(): string | undefined {
    return this._error;
  }
  set error(v: string | undefined) {
    this._error = v;
  }
  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  isValid = (showErrors: boolean) => {
    if (
      this.required &&
      (this._value === undefined ||
        this._value === null ||
        this._value.length === 0)
    ) {
      if (showErrors) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors) {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    this._value = e;
  };
}

export class BooleanAttribute {
  private _required: boolean;
  private _value: boolean | undefined;
  private _error: string | undefined;

  constructor(v?: boolean) {
    this._value = v;
  }

  get value(): boolean | undefined {
    return this._value;
  }

  set value(v: boolean | undefined) {
    if (v === undefined) {
      this._value = v;
    } else {
      this._value = v ? true : false;
    }
  }

  get error(): string | undefined {
    return this._error;
  }
  set error(v: string | undefined) {
    this._error = v;
  }
  get required(): boolean {
    return this._required;
  }

  set required(v: boolean) {
    this._required = v;
  }

  isValid = (showErrors: boolean) => {
    if (this.required && (this._value === undefined || this._value === null)) {
      if (showErrors) {
        this._error = 'This field is required';
      }
      return false;
    }

    if (showErrors) {
      this._error = undefined;
    }

    return true;
  };

  handleChange = (e: any) => {
    const v = e.target.value;
    if (v === undefined || v === null || v === -1) {
      this._value = undefined;
    } else {
      this._value = v ? true : false;
    }
  };
}

export class Definition {
  baseKey: string;
  popperAttributes?: any;
  patch: any;
  key: string;
  path: string;
  title: string;
  requireCaptchaVersion: string;
  suppressTitle: string;
  predefined: Array<PredefinedField>;
  user: Array<UserDefinedField>;
  definitions: Array<Definition>;
  allowsMultiples: boolean;
  singleRecordSelector: string;
  primedMultiples?: number;
  emptySetMesssage?: string;
  usePaging: boolean;
  allowSelection: boolean;
  minCount?: number;
  maxCount?: number;
  instructions?: string;
  customRenderer?: string;
  customMessages?: any;
  sortOptions?: any;
  allowOptionsFilter?: boolean;
  multiFormSelector?: any;
  historicalURL?: string;
  restrictHistoryToFeature?: string;
  multiFormCancelButtonProps?: any;
  multiFormCompleteButtonProps?: any;
  styleAttributes?: any;
  labelStyleAttributes?: any;
  gridAttributes?: any;
  emptySetRenderer?: any;
  pageSizeOptions?: any;
  allowsMultiplesShouldConfirmDelete?: any;
  hidableResults?: boolean;
  
  constructor(props?: any) {
    if (props) {
      this.baseKey = props.baseKey;
      this.popperAttributes = props.popperAttributes
      this.patch = props.patch;
      this.key = props.key;
      this.path = props.path
      this.gridAttributes = props.gridAttributes;
      this.title = props.title;
      this.requireCaptchaVersion = props.requireCaptchaVersion
      this.suppressTitle = props.suppressTitle;
      this.predefined = props.predefined || [];
      this.user = props.user || [];
      this.definitions = new Array<Definition>();
      if (props.definitions) {
        const defs = new Array<Definition>();
        props.definitions.forEach((d: any) => {
          defs.push(new Definition(d));
        });
        this.definitions = defs;
      }
      this.allowsMultiples = props.allowsMultiples;
      this.primedMultiples = props.primedMultiples;
      this.singleRecordSelector = props.singleRecordSelector;
      this.emptySetMesssage = props.emptySetMesssage;
      this.allowSelection = props.allowSelection;
      this.usePaging = props.usePaging;
      this.minCount = props.minCount;
      this.maxCount = props.maxCount;
      this.instructions = props.instructions;
      this.historicalURL = props.historicalURL;
      this.restrictHistoryToFeature = props.restrictHistoryToFeature;
      this.customRenderer = props.customRenderer
      this.customMessages = props.customMessages
      this.sortOptions = props.sortOptions
      this.multiFormSelector = props.multiFormSelector
      this.multiFormCancelButtonProps = props.multiFormCancelButtonProps
      this.multiFormCompleteButtonProps = props.multiFormCompleteButtonProps

      this.styleAttributes = props.styleAttributes
      this.labelStyleAttributes = props.labelStyleAttributes
      this.emptySetRenderer = props.emptySetRenderer

      this.pageSizeOptions = props.pageSizeOptions
      this.allowsMultiplesShouldConfirmDelete = props.allowsMultiplesShouldConfirmDelete
      this.hidableResults = props.hidableResults;

    } else {
      this.predefined = new Array<PredefinedField>();
      this.user = Array<UserDefinedField>();
      this.definitions = new Array<Definition>();
    }
  }


  updateDefinition(key: string, field: Definition) {
    if (this.definitions) {
      this.definitions.forEach((f) => {
        if (f.key == key) {
          f = field;
        }
      });
    }
  }

  hasExtractableFields(): boolean {
    let hasFields:boolean = false;
    if (this.predefined) {
      let pdf:boolean = this.predefined.some((p) => {
        return p.allowExtraction
      });
      if (pdf) {
        hasFields = true;
      }
    }
    if (this.definitions) {
      let ddf:boolean = this.definitions.some((d) => {
        return d.hasExtractableFields();
      });
      if (ddf) {
        hasFields = true;
      }
    }
    return hasFields;
  }

  setFieldMode(
    key: string,
    mode: 'Required' | 'Optional' | 'Read Only' | 'Hidden' | 'Key Field'
  ) {
    this.predefined.forEach((f) => {
      if (f.key == key) {
        f.mode = mode;
      }
    });
  }

  updatePredifinedField(key: string, field: PredefinedField) {
    this.predefined.forEach((f) => {
      if (f.key == key) {
        f.title = field.title;
        f.mode = field.mode;
        f.locked = field.locked;
      }
    });
  }

  updateUserField(key: string, field: UserDefinedField) {
    this.user.forEach((f) => {
      if (f.key == key) {
        f.title = field.title;
        f.mode = field.mode;
        f.locked = field.locked;
        f.type = field.type;
      }
    });
  }

  getPredifinedFieldDef(key: string): PredefinedField | undefined {
    for (const f of this.predefined) {
      if (f.key == key) {
        return f;
      }
    }
    return undefined;
  }

  isPredifinedFieldRequired(key: string): boolean {
    for (const f of this.predefined) {
      if (f.key == key) {
        return f.mode == 'Required';
      }
    }
    return false;
  }

  isUserDefinedFieldRequired(key: string): boolean {
    for (const f of this.user) {
      if (f.key == key) {
        return f.mode == 'Required';
      }
    }
    return false;
  }

  // TODO: Change the default return to true in the event a field is not found in the definition, it will be hidden.
  isPredifinedFieldHidden(key: string): boolean {
    for (const f of this.predefined) {
      if (f.key == key) {
        return f.mode == 'Hidden';
      }
    }
    return false;
  }

  predefinedFieldExists(key: string): boolean {
    for (const f of this.predefined) {
      if (f.key == key) {
        return true;
      }
    }
    return false;
  }

  isPredifinedFieldDisabled(key: string): boolean {
    for (const f of this.predefined) {
      if (f.key == key) {
        return f.mode == 'Read Only';
      }
    }
    return false;
  }

  getPredifinedFieldTitle(key: string, defaultValue: string): string {
    var found = false;
    for (const f of this.predefined) {
      if (f.key == key) {
        found = true;
        return f.title || defaultValue;
      }
    }
    if (!found) {
      // console.warn(key + " not found in form definition.", this.predefined)
    }
    return defaultValue;
  }

  getUserFieldDef(key: string): UserDefinedField | null {
    for (const f of this.user) {
      if (f.key == key) {
        return f;
      }
    }
    return null;
  }

  getDefinition(key: string): Definition {
    for (const f of this.definitions) {
      if (
        f.key.toLowerCase() == key.toLowerCase() ||
        f.title.toLowerCase() == key.toLocaleLowerCase()
      ) {
        return f;
      }
    }
    return new Definition();
  }

  shouldSectionDisplay(): boolean {
    for (const pf of this.predefined) {
      // if any of the predefined fields are not hidden, then show
      if (pf.mode != 'Hidden') {
        // console.log("Showing ", pf)
        return true;
      }
    }

    for (const uf of this.user) {
      // if any of the user defined fields are not hidden, then show
      if (uf.mode != 'Hidden') {
        return true;
      }
    }

    for (const def of this.definitions) {
      // if there are contained definitions that have attributes to show, then show
      if (def.shouldSectionDisplay()) {
        return true;
      }
    }

    // if, after all of that we have not found anything to display, then do not display
    return false;
  }

  isDataComplete(data: any, showErrors: Boolean): boolean {
    let incomplete = false;
    for (const pf of this.predefined) {
      if (pf.mode == 'Required') {
        if (pf.path) {
          if (data[pf.path][pf.key].isValid) {
            data[pf.path][pf.key].required = true;
            if (!data[pf.path][pf.key].isValid(showErrors)) {

              incomplete = true;
            }
          } else {
            if (!data[pf.path][pf.key]) {
              incomplete = true;
            }
          }
        } else {
          if (data[pf.key] && data[pf.key].isValid) {
            data[pf.key].required = true;
            if (!data[pf.key].isValid(showErrors)) {
              incomplete = true;
            }
          } else {
            if (!data[pf.key]) {
              incomplete = true;
            }
          }
        }
      }
    }

    for (const uf of this.user) {
      if (uf.mode == 'Required') {
        if (!data[uf.key]) {
          incomplete = true;
        }
      }
    }

    if (incomplete) {
      return false;
    }
    return true;
  }

  getFieldDef(attribute: string): PredefinedField | undefined {
    if (!this.predefined) {
      this.predefined = [];
    }

    return this.predefined.find(
      (field: PredefinedField): boolean => {
        return field.key == attribute;
      }
    );
  }

  // getSubDefintion gets the definition for a sub def and may return null or undefined.
  getSubDefinition(attribute: string): Definition | undefined {
    if (!this.definitions) {
      this.definitions = [];
    }

    return this.definitions.find(
      (def: Definition): boolean => {
        return def.key == attribute;
      }
    );
  }
}

export class PredefinedField {
  constructor(props: any) {
    this.key = props.key;
    this.path = props.path;
    this.title = props.title;
    this.mode = props.mode;
    this.objectPath = props.objectPath;
    this.locked = props.locked;
    this.helpText = props.helpText;
    this.type = props.type;
    this.options = props.options;
    this.allowOptionsFilter = props.allowOptionsFilter
    this.allowsMultiples = props.allowsMultiples;
    this.autoFocus = props.autoFocus;
    this.comment = props.comment;
    this.protected = props.protected;
    this.defaultValue = props.defaultValue;
    this.minLength = props.minLength;
    this.maxLength = props.maxLength;
    this.minValue = props.minValue;
    this.maxValue = props.maxValue;
    this.precision = props.precision;
    this.minDate = props.minDate;
    this.maxDate = props.maxDate;
    this.useNoonTime = props.useNoonTime;
    this.useUTC = props.useUTC
    this.conditionalAttributes = props.conditionalAttributes;
    this.gridAttributes = props.gridAttributes;
    this.addressAttributes = props.addressAttributes
    this.checkboxGridAttributes = props.checkboxGridAttributes
    this.placeholder = props.placeholder;
    this.allowedCharacters = props.allowedCharacters;
    this.regex = props.regex;
    this.customRenderer = props.customRenderer
    this.variant = props.variant
    this.textAreaRowCount = props.textAreaRowCount
    this.mask = props.mask
    this.autoSuggestURL = props.autoSuggestURL
    // this.chipLimit = props.chipLimit
    this.probeAutoSuggestURL = props.probeAutoSuggestURL
    this.suggestionRenderer = props.suggestionRenderer
    this.suppressAutoSelection = props.suppressAutoSelection
    this.minQueryChars = props.minQueryChars
    this.nullOptionLabel = props.nullOptionLabel
    this.legacy = props.legacy
    this.parse = props.parse
    this.acceptedDocumentTypes = props.acceptedDocumentTypes
    this.styleAttributes = props.styleAttributes
    this.labelStyleAttributes = props.labelStyleAttributes
    this.relationType = props.relationType;
    this.pagerThreshold = props.pagerThreshold;
    this.pageSize = props.pageSize;
    this.requireAddress1 = props.requireAddress1
    this.requireAddress2 = props.requireAddress2
    this.requireCity = props.requireCity
    this.requireState = props.requireState
    this.requirePostalCode = props.requirePostalCode
    this.requireCountry = props.requireCountry
    this.suppressCountry = props.suppressCountry
    this.suppressAddress2 = props.suppressAddress2
    this.showAddress3 = props.showAddress3
    this.portalListOptionsKey = props.portalListOptionsKey
    this.portalUserFieldFulfillmentURL = props.portalUserFieldFulfillmentURL
    this.hidePublicSelector = props.hidePublicSelector
    this.appendToQuery = props.appendToQuery
    this.fieldInfo = props.fieldInfo
    this.richTextOptions = props.richTextOptions
    this.triggerValidationAtURL = props.triggerValidationAtURL
    this.maxSize = props.maxSize
    this.defaultDocumentURL = props.defaultDocumentURL
    this.chipAttributes = props.chipAttributes
    this.relationListAttributes = props.relationListAttributes
    this.allowExtraction = props.allowExtraction
  }

  key: string;
  path: string;
  title: string;
  mode: 'Required' | 'Optional' | 'Read Only' | 'Display' | 'Hidden' | 'Key Field';
  objectPath?: string;
  locked?: boolean;
  helpText?: string;
  userDefined?: boolean;
  parse?: boolean;
  acceptedDocumentTypes?: string;
  type:
    | 'Text'
    | 'Number'
    | 'Numeric'
    | 'Currency'
    | 'Date'
    | 'DateTime'
    | 'Bool'
    | 'Boolean'
    | 'VersionedDocument'
    | 'VersionedDocumentList'
    | 'RichText'
    | 'DocumentList'
    | "NumericRange"
    | "DateRange"
    | "PortalUser"
    | "Address"
    | "Json";

  options?: Array<any>;

  allowOptionsFilter?: boolean;

  allowsMultiples?: boolean;

  autoFocus?: boolean;

  // Comment will NOT be used, but may be displayed to the user in admin
  comment?: string;

  // Protected refelcts that the field should
  protected?: boolean;

  defaultValue?: any;

  // Text Field attributes
  minLength?: number;
  maxLength?: number;

  // row count for TextArea Variant.
  textAreaRowCount?: number;

  // Numeric/Currency attributes
  minValue?: number;
  maxValue?: number;


  precision?: number;

  // Date attributes
  // These attributes are intended to allow for easy entry of relative dates
  // Values such a `-90d`, `- 90 days`, `2w` and `1 year` are anticipated
  // This regex should parse out the query parts sign, amount, duration that can then be used with moment to derive the realtive date.
  //
  // ([+-]?)\s*(\d+)\s*(\w+)+
  //
  // See https://momentjs.com/docs/#/durations/

  minDate?: string;
  maxDate?: string;
  useNoonTime?: boolean;
  useUTC?: boolean;

  // This is used for the DocumentList, setting to true will hide the Public? checkbox
  hidePublicSelector?: boolean

	// ConditionalAttributes allow one to determine the mode based upon the relative value of an element at path and a string representation of the value collected in the interface.  The first condition to be met will update the mode.
  conditionalAttributes?: Array<any>;

  // Attributes related to grid spacing
  gridAttributes?: any;

  // The sizing options for evenly spaced checkbox options on Text Variant: checkbox
  checkboxGridAttributes?: any

  // Overriding attributes to set props for sub-fields within an address field, those props are listed below
  addressAttributes?: any
    // label


  // Attributes related to style
  styleAttributes?: any;

  // Attributes related to style of the label
  labelStyleAttributes?: any;

  // Placeholder
  placeholder?: string;

  // Allowed Characters
  allowedCharacters?: string;

  // Regex Characters
  regex?: string;

	// Customer renderer allows one to specify the custom renderer for the field.  The customer renderer much be registered in the client application.  If no customer renderer is found, the default rendering method will be used
  customRenderer?: string;

	// Variant allows one to indicate to the rendering control which variant should be used (eg. Switch, Checkbox, etc.)
  variant?: string;

	// The mask to be used to assist the user in data entry.  Not used for form-base validation, use regex for validation.
  mask?: string;

	// AutoSuggestURL directs the UI to use the URL to provide autosuggest.
	// The URL must ahdere to the options data structure and should accept a `term` querystring parameter.
  autoSuggestURL?: string;

  probeAutoSuggestURL?: boolean;

  suggestionRenderer?: string;

  // If present, and the field uses probeAutoSuggestURL, the field will not automatically select the value on a single result return. 
  suppressAutoSelection?: boolean

  minQueryChars?: number;

  nullOptionLabel?: string;

  // AddressField Attributes
  showCountry?: boolean;
  requireAddress1?: boolean;
  requireAddress2?: boolean;
  requireCity?: boolean;
  requireState?: boolean;
  requirePostalCode?: boolean;
  requireCountry?: boolean;
  showAddress3?: boolean;
  suppressCountry?: boolean;
  suppressAddress2?: boolean;


  relationType?: string;
  // PortalUser Field attributes
  portalUserFieldFulfillmentURL?: string;

  // If provided, options for the state field will be sourced from portal_list_options by key
  portalListOptionsKey?: string;

  // This is a legacy field, so we are going to limit what is available
  legacy?: boolean;

  // // Sets the upper limit for chips to be collapsed in a Relation List Chip variant
  // chipLimit?: number;
  // sets the minimum number of items in a relation list to use paging
  pagerThreshold?: number;
  // size for the above relationlist threshold
  pageSize?: number;

  // appendToQuery is used by the relation field
  appendToQuery?: Array<any>;

  // display field information popper
  fieldInfo?: any;

  // rich text options
  richTextOptions?: any;

  // If present, will call out to the api route declared here when blurring away from the field
  triggerValidationAtURL?: string

  // max file size for document fields
  maxSize?: number

  // default document for versioned document fields 
  defaultDocumentURL?: string;

  // chip attributes
  // Supports styleAttributes, chiplimit, regex.
  chipAttributes?: any;

  // attributes used to control relation list behavior
  relationListAttributes?: any;

  // indicates that the field is availble for extraction
  allowExtraction?: boolean;
}

export class UserDefinedField extends PredefinedField {
  constructor(props: any) {
    super(props)
  }
}

export class FieldMode {
  constructor(v: any) {
    this.key = v.key;
    this.icon = v.icon;
  }
  icon: string;
  key: 'Read Only' | 'Optional' | 'Hidden' | 'Required';
}

export class FieldType {
  constructor(v: any) {
    this.key = v.key;
    this.icon = v.icon;
  }
  icon: string;
  key: 'Text' | 'Date' | 'Number' | 'Boolean';
}

export class CompleteProfile {
  companyInformation: Profile;
  paymentDetails: ProfilePaymentDetail;
  owners: Array<ProfileOwner>;
  addressInformation: Array<ProfileAddress>;
  affiliatesSubsidiaries: Array<ProfileAffilation>;
  references: Array<ProfileReference>;
  contactInformation: Array<ProfileContact>;
  taxInfo: ProfileTaxInfo;
  ownershipDiversity: ProfileDiversity;
  diversityCerts: Array<ProfileDiversityCertificate>;
  insurance: ProfileInsuranceInfo;
  insurancePolicies: Array<ProfileInsurancePolicy>;
  licensesPermits: Array<ProfileLicense>;
  productsServices: ProfileProductInfo;
  sustainability: ProfileSustainabilityInfo;
  tasks: Array<ProfileTask>;

  constructor(v?: any) {
    this.companyInformation = new Profile(v.companyInfo);
    this.paymentDetails = new ProfilePaymentDetail(v.paymentDetails);
    this.taxInfo = new ProfileTaxInfo(v.taxInfo);
    this.ownershipDiversity = new ProfileDiversity(v.ownershipDiversity);
    this.insurance = new ProfileInsuranceInfo(v.insurance);
    this.productsServices = new ProfileProductInfo(v.productInfo);
    this.sustainability = new ProfileSustainabilityInfo(v.sustainability);

    this.owners = [];
    if (v.owners && v.owners.length > 0) {
      v.owners.forEach((o: any) => {
        this.owners.push(new ProfileOwner(o));
      });
    }
    this.addressInformation = [];
    if (v.addresses && v.addresses.length > 0) {
      v.addresses.forEach((a: any) => {
        this.addressInformation.push(new ProfileAddress(a));
      });
    }
    this.affiliatesSubsidiaries = [];
    if (v.affiliations && v.affiliations.length > 0) {
      v.affiliations.forEach((a: any) => {
        this.affiliatesSubsidiaries.push(new ProfileAffilation(a));
      });
    }
    this.references = [];
    if (v.references && v.references.length > 0) {
      v.references.forEach((r: any) => {
        this.references.push(new ProfileReference(r));
      });
    }

    this.contactInformation = [];
    if (v.contacts && v.contacts.length > 0) {
      v.contacts.forEach((c: any) => {
        this.contactInformation.push(new ProfileContact(c));
      });
    }

    this.diversityCerts = [];
    if (v.diversityCerts && v.diversityCerts.length > 0) {
      v.diversityCerts.forEach((dc: any) => {
        this.diversityCerts.push(new ProfileDiversityCertificate(dc));
      });
    }
    this.insurancePolicies = [];
    if (v.insurancePolicies && v.insurancePolicies.length > 0) {
      v.insurancePolicies.forEach((ip: any) => {
        this.insurancePolicies.push(new ProfileInsurancePolicy(ip));
      });
    }
    this.licensesPermits = [];
    if (v.licenses && v.licenses.length > 0) {
      v.licenses.forEach((l: any) => {
        this.licensesPermits.push(new ProfileLicense(l));
      });
    }
    this.tasks = [];
    if (v.tasks && v.tasks.length > 0) {
      v.tasks.forEach((t: any) => {
        this.tasks.push(new ProfileTask(t));
      });
    }
  }
}


